export enum SitemapContinents {
    Africa = 'Africa',
    Asia = 'Asia',
    Australia = 'Australia',
    Europe = 'Europe',
    NorthAmerica = 'North America',
    SouthAmerica = 'South America'
}

export enum SitemapContinentRoutes {
    Africa = 'Africa',
    Asia = 'Asia',
    Australia = 'Australia',
    Europe = 'Europe',
    NorthAmerica = 'North-America',
    SouthAmerica = 'South-America'
}

export type ContinentNameTypes = | 'Africa' | 'Asia' | 'Australia' | 'Europe' | 'North America' | 'South America';

export enum SitemapLocationRoutes {
    continent = 'continent',
    country = 'country',
    state = 'state',
    statecode = 'statecode'
}

export enum SitemapLocationsRoutePaths {
    countriesByContinent = '/sitemap/:continent',
    citiesByCountryNonUS = '/sitemap/:continent/:country/:isocode',
    statesByCountry = '/sitemap/:continent/:country/states',
    citiesByState = '/sitemap/:continent/:country/state/:state/:statecode'
}

export interface CountriesByContinentType {
    Name: string;
    ShortName: string;
    Iso3: string;
    Iso2: string;
    Fips: string;
}

export interface StatesByCountryType {
    Name: string;
    Abbreviation: string;
}

export enum LinkTitles {
    nowForecast = 'Current Weather Forecast',
    hourlyForecast = 'Hourly weather forecast',
    dailyForecast = '10-day weather forecast',
    alerts = 'View current weather alerts and warnings',
    maps = 'Live Weather Radar Map'
}

export interface SitemapCityByCountryType {
    CityId: string;
    SlugName: string;
    Confirmed: string | null;
    AqiId: string | null;
    CityName: string;
    CountyMunicipality: string | null;
    Dma: string | null;
    FipsCountry: string | null;
    ForecastCityId: string | null;
    ForecastZoneId: string | null;
    Latitude: number;
    Longitude: number;
    PollenId: string | null;
    PopulationSort: number | null;
    PostalCode: string | null;
    SchemaVersion: number;
    StateProvince: string | null;
    StateCode: string | null;
    TimeZoneId: string | null;
    UvId: string | null;
    CountryIso2: string;
    CountryIso3: string;
}

export type CountriesByContinentResult = {
    Result: CountriesByContinentType[];
}

export type CitiesByCountryOrStateResult = {
    Result: SitemapCityByCountryType[];
}

type JsonLDListItem = {
    '@type': 'ListItem';
    position: number;
    name: string;
    item?: URL;
}

export type JsonLD = {
    '@context': 'https://schema.org';
    '@type': 'BreadcrumbList';
    itemListElement: JsonLDListItem[];
};